import { create } from 'zustand';
import { getTripKey } from '../../utils/tripAnalysis';
import { 
    sendPosition,
    sendPositionsBatch,
    sendDeletePosition
} from '../../channels/tripPositionsAnalysisChannel';

function hasPositionData(item) {
    return (
        item?.resultado != null ||
        item?.atendP != null ||
        item?.progressoPercurso != null ||
        item?.progressoPontos != null
    );
}

export const useTripPositionsAnalysisStore = create((set, get) => ({

    positionsMap: new Map(),

    getPosition: (date, codigo) => {

        return get().positionsMap.get(
            getTripKey(date, codigo)
        ) || null;

    },

    setPosition: (payload, broadcast = true) => {

        if (
            !payload?.date ||
            !payload?.codigo
        ) {
            return;
        }

        if (!hasPositionData(payload)) {
            return;
        }

        const positionsMap = new Map(
            get().positionsMap
        );

        positionsMap.set(
            getTripKey(payload.date, payload.codigo),
            payload
        );

        set({
            positionsMap
        });

        if (broadcast) {
            sendPosition(payload);
        }

    },

    setPositionsBatch: (items = [], broadcast = true) => {

        if (items.length === 0) {
            return;
        }

        const positionsMap = new Map(
            get().positionsMap
        );

        for (const item of items) {

            if (
                !item?.date ||
                !item?.codigo
            ) {
                continue;
            }

            if (!hasPositionData(item)) {
                continue;
            }

            positionsMap.set(
                getTripKey(item.date, item.codigo),
                item
            );

        }

        set({
            positionsMap
        });

        if (broadcast) {
            sendPositionsBatch(items);
        }

    },

    deletePosition: (date, codigo, broadcast = true) => {

        const positionsMap = new Map(
            get().positionsMap
        );

        positionsMap.delete(
            getTripKey(date, codigo)
        );

        set({
            positionsMap
        });

        if(broadcast){
            sendDeletePosition({date, codigo});
        }

    },

    exportPositions: () => {

        return [
            ...get().positionsMap.values()
        ];

    },

    clearPositions: () => {

        set({
            positionsMap: new Map()
        });

    }

}));